import React from 'react';
import { Card as MuiCard, CardContent } from '@mui/material';

const BaseCard = ({ children, maxWidth = 400 ,}) => {
  return (
    <MuiCard
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: maxWidth,
        mx: 'auto',
        mt: 5,
       
        padding: 2,
        py:3,
        border:"1px solid #eee",
        borderRadius:"12px",
        border:"none",
        overflow:"visible",
 
        // zIndex:1,
      }}
      
    >
      <CardContent>
        {children}
      </CardContent>
    </MuiCard>
  );
};

export default BaseCard;

